import React from "react";
import "./Header.css";
import img from "../assets/bb_logo.png";
import img1 from "../assets/img1.png";
import img2 from "../assets/img2.png";
import img3 from "../assets/img3.png";
import img4 from "../assets/img4.png";
import img5 from "../assets/img5.png";
import img6 from "../assets/img6.png";
import img7 from "../assets/img7.png";
import { useCountry } from "../utility/utility";
import { useLocation } from "react-router-dom";

const Header = ({ onBookDemo }) => {
  const { countryCode } = useCountry();
  const { pathname } = useLocation()
  return (
    <>
      <div className="announcement-bar">
        🎉{" "}
        <span>
          Limited Offer: <strong>Free NFC Card + Setup</strong> with any plan
          this month — <strong>50 spots left</strong>
        </span>
      </div>

      <header className="navbar">
        <div className="nav-main">
          <a href="/" className="navbar-logo">
            <div className="logo-img">
              <img src={img} alt="error" />
            </div>
          </a>

          <div className="navbar-right">
            {pathname === "/" && <a href={`tel:${countryCode === "ae" ? "971562198924" : "917835065469"}`} className="navbar-phone">
              📞 {countryCode === "ae" ? "+971-562198924" : "+91-7835065469"}
            </a>}
            {/* <button className="demo-btn" onClick={onBookDemo}>
                Book Free Demo →
              </button> */}

            <a href="https://dashboard.businessbay.io/login" target="_blank" className="demo-btn">
              Login / Signup
            </a>
          </div>



        </div>
        <div className="nav-strip mainclass">
          <ul className="strip-links maxwidth">
            <li>
              <a href="https://marketplace.businessbay.io/" target="blank">
                <span className="strip-icon">
                  <img src={img1} alt="error" />
                </span>{" "}
                Market place
              </a>
            </li>
            <li>
              <a href="https://ecommerce.businessbay.tech/" target="blank">
                <span className="strip-icon">
                  <img src={img2} alt="error" />
                </span>{" "}
                E-Commerce Store
              </a>
            </li>
            <li>
              <a href="https://businessbay.io/realestate/" target="blank">
                <span className="strip-icon">
                  <img src={img3} alt="error" />
                </span>{" "}
                Real Estate
              </a>
            </li>
            <li>
              <a href="https://influencer.businessbay.tech/" target="blank">
                <span className="strip-icon">
                  <img src={img4} alt="error" />
                </span>{" "}
                Influencer Program
              </a>
            </li>
            <li>
              <a href="https://restaurant.businessbay.io/" target="blank">
                <span className="strip-icon">
                  <img src={img5} alt="error" />
                </span>{" "}
                Food Mart
              </a>
            </li>
            <li>
              <a href="https://nfccard.businessbay.io/" target="blank">
                <span className="strip-icon">
                  <img src={img6} alt="error" />
                </span>{" "}
                NFC Smart Card
              </a>
            </li>
            <li>
              <a href="https://cab.businessbay.io/" target="blank">
                <span className="strip-icon">
                  <img src={img7} alt="error" />
                </span>{" "}
                Cab Service
              </a>
            </li>
          </ul>
        </div>
      </header>
    </>
  );
};

export default Header;
